import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cookies } from '@utils/cookies';

const tagTypes = [
    'ExtendedWarranty',
    'Events',
    'User',
    'Users',
    'UsersRoles',
    'UserDetails',
    'Countries',
    'Languages',
    'Timezones',
    'Markets',
    'EventAttendees',
    'PublicEvents',
    'Roles',
    'CompanyTypesAllowed',
    'SalesManagers',
    'UserRequests',
    'UserCompanies',
    'EventUrls',
    'Blog Posts',
    'EventBlacklist',
    'OnlineTraining',
    'Inbox',
    'MediaAssetsDropboxFiles',
    'FirmwaresDropboxFiles',
    'RepairdocsDropboxFiles',
    'Distributors',
    'GuestUser',
    'MyEvents',
    'End User',
    'MyEarnedBadges',
    'TwoFARoles',
    'CheckEmail',
    'KeycloakLoginUrl',
    'UserCredentialTypes',
    'Services',
    'States',
];

const baseQuery = fetchBaseQuery({
    baseUrl: '/api-professional/',
    prepareHeaders: (headers) => {
        headers.set('X-CSRFToken', cookies.get('csrftoken') ?? '');
        return headers;
    },
    credentials: 'include',
});

export const api = createApi({
    baseQuery: baseQuery,
    tagTypes,
    endpoints: () => ({}),
});
